import React from "react";
import "./Projects.css";
import ProjectCard from "./ProjectCard";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Projects = ({ projectsRef }) => {
    const projects = [
        {
            name: "Vocabooster",
            title: "Vocabulary Booster",
            link: "https://vocabooster.vercel.app",
            info: "Improve your vocabulary by learning new words and idioms",
            tech: ["React.js", "Express.js", "MongoDB", "CSS"],
            github: "https://github.com/shmiitg/vocabooster",
        },
        {
            name: "Codedunk",
            title: "Interview Preparation Tracker",
            link: "https://codedunk.onrender.com",
            info: "Keep track of your interview progress and crack them",
            tech: ["React.js", "Express.js", "JavaScript", "MongoDB", "CSS"],
            github: "https://github.com/shmiitg/code-dunk",
        },
        {
            name: "Portgen",
            title: "Portfolio Generator",
            link: "https://portgen.vercel.app",
            info: "Generate multiple portfolio by filling required details",
            tech: ["React.js", "Express.js", "Passport.js", "JavaScript", "MongoDB", "CSS"],
            github: "https://github.com/shmiitg/portgen",
        },
        {
            name: "Redstore",
            title: "Ecommerce Website",
            link: "https://redstore.vercel.app",
            info: "Check out amazing products and get them ordered to your address",
            tech: ["Express.js", "JavaScript", "EJS", "Passport.js", "MongoDB", "CSS"],
            github: "https://github.com/shmiitg/redstore",
        },
        {
            name: "TaskUp",
            title: "Project Manager",
            link: "",
            info: "Manage your pending and completed projects at one place",
            tech: ["React.js", "Express.js", "MySQL", "CSS"],
            github: "https://github.com/shmiitg/taskup",
        },
    ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1048,
                settings: {
                    dots: true,
                    infinite: true,
                    speed: 500,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    autoplay: true,
                },
            },
            {
                breakpoint: 700,
                settings: {
                    dots: true,
                    infinite: true,
                    speed: 500,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                },
            },
        ],
    };

    return (
        <div className="proj-container" ref={projectsRef}>
            <div className="heading">Projects</div>
            <div className="proj-slider">
                <Slider {...settings}>
                    {projects.map((project, index) => (
                        <ProjectCard
                            key={index}
                            name={project.name}
                            title={project.title}
                            link={project.link}
                            info={project.info}
                            tech={project.tech}
                            github={project.github}
                        />
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default Projects;
